


















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ExTextLayer } from "@/model/document2/page/surface/design/layer/exTextLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import TextColorController from "./textColorController/textColorController.vue";
import FontSizeController from "./fontSizeController/fontSizeController.vue";
import FontStyleController from "./fontStyleController/fontStyleController.vue";
import TextOutlineController from "./textOutlineController/textOutlineController.vue";
import TextOutlineColorController from "./textOutlineColorController/textOutlineColorController.vue";
import TextShadowColorController from "./textShadowColorController/textShadowColorController.vue";
import TextSpacingController from "./textSpacingController/textSpacingController.vue";
import TextShadowController from "./textShadowController/textShadowController.vue";

@Component({
    components: {
        TextColorController,
        FontSizeController,
        FontStyleController,
        TextOutlineController,
        TextOutlineColorController,
        TextShadowColorController,
        TextSpacingController,
        TextShadowController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextController extends Vue 
{
    @Prop() layer! : ExTextLayer;

    private textControllerType = "textColor";

    private isActive(type)
    {
        return this.textControllerType == type;
    }

    private changeType(type : string)
    {
        this.textControllerType = type;
    }

    private onChangeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changePlainTextLayerWholeTextInfo", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private onRequestColor(propertyName : string, currentValue : ColorConstruct)
    {
        var parameter = {};
        parameter["propertyName"] = propertyName;
        parameter["type"] = "color";
        var hex = currentValue.hex;
        if(hex.substr(0, 1) == "#") { hex = hex.substr(1, 6); }
        parameter["currentValue"] = hex;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }

    private changeText()
    {
        var parameter = {};
        parameter["propertyName"] = "text";
        parameter["type"] = "string";
        parameter["currentValue"] = this.layer.text;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }

    private changeFont()
    {
        var parameter = {};
        parameter["propertyName"] = "fontId";
        parameter["type"] = "string";
        var currentFont = this.getTextInfo("fontId");
        parameter["currentValue"] = currentFont != null ? currentFont : this.layer.baseTextInfo.fontId;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }

    private getTextInfo(name : string)
    {
        if(this.layer.textInfoArray.length == 0) { return this.layer.baseTextInfo[name]; }
        var val = this.layer.textInfoArray[0][name];
        for(var i = 1; i < this.layer.textInfoArray.length; ++i)
        {
            var isEqual = false;
            var lastVal = this.layer.textInfoArray[i][name];
            
            if(val == lastVal) { isEqual = true; }
            if(!isEqual) { return null; }
        }

        return val;
    }
}
